<template>
  <div class="app-content content">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row"></div>
      <div class="content-body">
        <div class="auth-wrapper auth-v2">
          <div class="auth-inner row m-0">
            <a class="brand-logo" href="javascript:void(0);"></a>
            <div class="d-none d-lg-flex col-lg-8 align-items-center">
              <div
                class="
                  w-100
                  d-lg-flex
                  align-items-center
                  justify-content-center
                "
              >
                <img :src="$assets('images/connexion.png')" alt="Login V2" />
              </div>
            </div>
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
              <div
                class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto"
                style="margin-top: -200px"
              >
                <img
                  class="img-fluid ml-2"
                  :src="$assets('images/logo.png')"
                  alt=""
                />
                <form class="auth-login-form mt-3">
                  <div class="mb-2">
                    <i data-feather="chevron-left"></i
                    ><span style="font-size: 12px; cursor: pointer"
                      ><u @click="back()">Retour</u></span
                    >
                  </div>
                  <h4 class="card-title font-weight-bold mb-1">Connexion</h4>
                  <p>
                    Veuillez entrer le code que vous avez reçu sur le N° de
                    téléphone {{ form.username }}
                  </p>
                  <div class="form-group">
                    <label class="">Code</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text"
                          ><i data-feather="lock"></i
                        ></span>
                      </div>
                      <input
                        class="form-control"
                        v-model="form.code"
                        type="number"
                      />
                    </div>
                    <div v-if="errors.code" style="color: red">
                      {{ errors.code[0] }}
                    </div>
                  </div>
                  <button
                    v-if="!loading"
                    @click.prevent="dashboard()"
                    class="btn btn-primary btn-block"
                  >
                    Vérifier
                  </button>
                  <button
                    v-else
                    class="btn btn-primary btn-block"
                    type="button"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="ml-25 align-middle">Loading...</span>
                  </button>
                </form>
                <p class="text-center mt-2">
                  <span style="font-size: 12px"
                    >En utilisant cette application, vous acceptez nos
                    <a
                      :href="$assets('terms')"
                      target="_blank"
                      style="color: #002a85"
                      >conditions d'utilisation</a
                    ></span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { api } from "../../../helpers/shared";
export default {
  name: "verify",
  props: {
    route: {
      type: String,
      default: () => "",
    },
    admin: {
      type: String,
      default: () => "",
    },
  },
  data: () => ({
    form: {
      username: "",
      code: "",
    },
    errors: [],
    loading: false,
  }),
  methods: {
    back() {
      this.$storage.removeItem("key_phone");
      this.$router("login");
    },
    dashboard() {
      this.loading = true;
      axios
        .post(api("auth/verify"), this.form)
        .then((response) => {
          this.loading = false;
          this.errors = [];
          if (response.data.status) {
            this.form.username = "";
            this.$storage.removeItem("key_phone");
            window.location.href = "/administration/dashboard";
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status === 401) {
          } else {
            this.errors = error.response.data.errors;
          }
        });
    },
  },
  mounted() {
    if (this.$storage.getItem("key_phone")) {
      this.form.username = this.$storage.decryptString(
        this.$storage.getItem("key_phone")
      );
    } else {
      this.form.username = "";
    }
  },
};
</script>

<style scoped>
</style>
